import { Box, Text } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants';

export const Container = Box.withConfig({
  backgroundColor: {
    base: 'transparent',
    md: primitive.$white,
  },
  padding: {
    base: '$0',
    md: '$6',
  },
  borderRadius: primitive.$borderRadius,
  shadow: {
    base: 'none',
    md: '1',
  },
});

export const Header = Text.withConfig({
  variant: 'headerOne',
  fontSize: '3xl',
  lineHeight: 'sm',
});

export const OrderNumber = Text.withConfig({
  variant: 'copyOne',
  marginBottom: '$4',
});

export const Instructions = Text.withConfig({
  variant: 'copyOne',
  marginY: '$1',
});
